/* tslint:disable */

/**
 */
export class BusStation {
    updated_at?: string;
    id?: number;
    address?: string;
    lat?: number;
    lng?: number;
    created_at?: string;
    name?: string;
    station_order?: number;
    url_sound?: string;
    str_audio_base64?: string;
    direction?: number;
    group_key?: string;
    station_relative?: string;
}
